import React from 'react';
import PropTypes from 'prop-types';

import {childrenPropTypes} from '../../../util/utils';

import StyledBorderBox from './StyledBorderBox';

const BorderBox = ({children, ...rest}) => {
	if (children === null) return null;
	const props = {...rest};
	return <StyledBorderBox {...props}>{children}</StyledBorderBox>;
};

BorderBox.propTypes = {
	children: childrenPropTypes,
	empty: PropTypes.bool
};

BorderBox.defaultProps = {
	children: null,
	empty: false
};

export default BorderBox;
